// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
//主组件
import App from './App'
//涟漪动画效果
//vue路由
import router from './router'
//vuex配置文件
import store from '@/config/store'
//常用过滤器
import filter from '@/config/filter'
Vue.use(filter);
//头部
import headTop from '@/components/header/head';
import footGuide from '@/components/footer/footGuide';
Vue.config.productionTip = false
//头部
Vue.component("head-top", headTop);
Vue.component("foot-guide", footGuide);

import zImage from '@/components/common/image.vue';
Vue.component("z-image", zImage);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})
